import { createRouter, createWebHistory } from 'vue-router'
import authRoutes from './modules/auth.routes'
import authGuard from './guards/authGuard'
import searchRoutes from './modules/search.routes'
import userRoutes from './modules/users.routes'
import facilitiesRoutes from './modules/facilities.routes'
import ordersRoutes from './modules/orders.routes'
import invoiceRoutes from './modules/invoices.routes'
import settingsRoutes from './modules/settings.routes'
import shoppingCartRoutes from './modules/cart.routes'
import checkoutRoutes from './modules/checkout.routes'
import channelRouter from './modules/channel.router'
import reportsRoutes from './modules/reports.routes'


import MainLayout from '../components/layout/MainLayout.vue'


const routes = [
  ...authRoutes,
  ...channelRouter,
  {
    path: '/',
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      ...searchRoutes,
      // ...productRoutes,
      ...userRoutes,
      ...facilitiesRoutes,
      ...ordersRoutes,
      ...invoiceRoutes,
      ...settingsRoutes,
      ...shoppingCartRoutes,
      ...checkoutRoutes,
      ...reportsRoutes
    ]
  }
]


const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Restore saved position when using browser back/forward
    if (savedPosition) {
      return savedPosition;
    }

    // Scroll to top on every route change
    return {
      top: 0,
      behavior: 'smooth'
    };
  }
})

router.beforeEach(authGuard)

const DEFAULT_TITLE = 'Flightline App'

router.afterEach((to) => {
  document.title = to.meta?.title
    ? `${to.meta.title} | ${DEFAULT_TITLE}`
    : DEFAULT_TITLE
})
let previousRoute = null

router.beforeEach((to, from, next) => {
  previousRoute = from
  next()
})

export { previousRoute }

export default router